import React from 'react';
import { usePreferences } from '../../contexts/PreferencesContext';

const TableEmptyState = ({
  title,
  description,
  icon = '📋',
  className = '',
}) => {
  const { t } = usePreferences();

  return (
    <div className={`empty-module table-state-spacing table-empty-module ${className}`}>
      <div className="empty-module-icon">{icon}</div>
      <h3>{title}</h3>
      <p>{description || t('empty_state_default_description')}</p>
    </div>
  );
};

export default TableEmptyState;
